import { Currency } from 'domain/Currency/Currency'

import { LineItemMetaInterface } from './LineItemMetaInterface'

export interface LineItemInterface {
  type: string
  name: string
  code: string
  description: string
  unitPrice: Currency
  quantity: number
  total: Currency
  totalEUR?: number
  exchangeRate: number
  reference: string[]
  currencyExchangeRateId: string
  meta?: LineItemMetaInterface
}

export function totalCost(lineItems: LineItemInterface[]): number {
  return sumLineItems(lineItems)
}

export function sumLineItems(lineItems: LineItemInterface[]) {
  if (!lineItems) {
    return 0
  }
  return lineItems.reduce((sum, lineItem) => {
    if (!lineItem) return sum
    if (lineItem.total.code === '%') {
      return sum * (1 + lineItem.total.value / 100)
    }
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    return sum + lineItem.totalEUR
  }, 0)
}
